// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"518":"1519a113","633":"c270f3d2","636":"2e96ab42","715":"65377443","768":"75b70012","790":"498a6309","906":"f4f59908","993":"259fa6aa"}[chunkId] + ".js";
};